import { SVGProps } from "react";

/** El asistente de IA (#633): el cuerpo del operador con cabeza de robot. */
export function AgentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 22c0-4.4 3.6-7 8-7s8 2.6 8 7" />
      <rect x="7" y="5" width="10" height="7" rx="2" />
      <path d="M12 5V2.5M4.5 7.5v2M19.5 7.5v2" />
      <circle cx="10" cy="8.5" r=".6" fill="currentColor" />
      <circle cx="14" cy="8.5" r=".6" fill="currentColor" />
    </svg>
  );
}
